"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftwareLicenseGoogleDriveAction = SoftwareLicenseGoogleDriveAction;
exports.default = SoftwareLicensesSearch;
const react_1 = __importStar(require("react"));
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const SoftwareLicensesController_1 = require("./SoftwareLicensesController");
const SoftwareLicenseFilterBody_1 = require("./SoftwareLicenseFilterBody");
const SoftwareLicenseModalButtons_1 = require("./Modals/SoftwareLicenseModalButtons");
const SoftwareLicenseKey_1 = require("./SoftwareLicenseKey");
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const date = (value) => value ? value.split("-").reverse().join(".") : "Nie podano";
function SoftwareLicenseGoogleDriveAction({ dataObject, layout }) {
    return dataObject.googleDriveUrl ? react_1.default.createElement(CommonComponents_1.GDFolderIconLink, { folderUrl: dataObject.googleDriveUrl, layout: layout }) : null;
}
function SoftwareLicensesSearch({ title }) {
    (0, react_1.useEffect)(() => { document.title = title; }, [title]);
    return react_1.default.createElement(FilterableTable_1.default, { id: "softwareLicenses", title: title, FilterBodyComponent: SoftwareLicenseFilterBody_1.SoftwareLicensesFilterBody, repository: SoftwareLicensesController_1.softwareLicensesRepository, searchOnMount: true, AddNewButtonComponents: [SoftwareLicenseModalButtons_1.SoftwareLicenseAddNewModalButton], EditButtonComponent: SoftwareLicenseModalButtons_1.SoftwareLicenseEditModalButton, isDeletable: true, RowActionMenuComponents: [SoftwareLicenseGoogleDriveAction], tableStructure: [
            { header: "Produkt", colMd: 3, renderTdBody: item => react_1.default.createElement("div", { style: { overflowWrap: "anywhere" } },
                    react_1.default.createElement("strong", null, item.product),
                    react_1.default.createElement("div", null,
                        item.manufacturer,
                        " ",
                        item.version),
                    react_1.default.createElement("small", null, item.licenseType === "Subscription" ? "Subskrypcja" : item.licenseType)) },
            { header: "Stanowiska", colMd: 2, renderTdBody: item => react_1.default.createElement("div", null,
                    "Kupione: ",
                    item.seatsPurchased,
                    react_1.default.createElement("br", null),
                    "Zaj\u0119te: ",
                    item.seatsUsed,
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("strong", null,
                        "Wolne: ",
                        item.seatsFree)) },
            { header: "Wygaśnięcie / status", colMd: 2, renderTdBody: item => react_1.default.createElement("div", { style: { overflowWrap: "anywhere" } },
                    date(item.expirationDate),
                    react_1.default.createElement("div", null, item.status)) },
            { header: "Przypisanie", colMd: 2, renderTdBody: item => react_1.default.createElement("div", { style: { overflowWrap: "anywhere" } }, item.assignment || "Nie podano") },
            { header: "Klucz", colMd: 2, renderTdBody: item => react_1.default.createElement(SoftwareLicenseKey_1.SoftwareLicenseKey, { key: item.updatedAt, license: item }) },
        ] });
}
